import { Expose, plainToInstance } from "class-transformer";
import { IsBoolean, IsNotEmpty } from "class-validator";

export class BuildProjectProgress {
  public static from(steps: BuildProjectProgress): BuildProjectProgress {
    return plainToInstance(BuildProjectProgress, steps, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsBoolean()
  @IsNotEmpty()
  hasMatches!: boolean;
}
